import jwt_decode from "jwt-decode";

export default function isLegacyAdminUser(token) {
  if (!token) return false;
  const decodedToken = jwt_decode(token);
  const { id } = decodedToken || {};
  const isLegacy = id.includes("user#");
  return isLegacy;
}
